/**
 * sl-9qm.4.3: Register Data + Navigation Components
 *
 * Called during StreamLain module initialization to register
 * all 7 data and navigation components in the ComponentRegistry.
 */
import type { ComponentRegistry } from '../../services/component-registry';
import { BarChartComponent } from './data/bar-chart';
import { KPICardComponent } from './data/kpi-card';
import { LineChartComponent } from './data/line-chart';
import { AppBaseFooterComponent } from './navigation/app-base-footer';
import { AppBaseHeaderComponent } from './navigation/app-base-header';
import { AppBaseNavigationComponent } from './navigation/app-base-navigation';
import { BreadcrumbComponent } from './navigation/breadcrumb';
import { FilterBarComponent } from './navigation/filter-bar';
import { LanguageSwitcherComponent } from './navigation/language-switcher';
import { PaginationComponent } from './navigation/pagination';
import { SearchBarComponent } from './navigation/search-bar';

export function registerDataAndNavComponents(
  registry: ComponentRegistry
): void {
  // Data components
  registry.register(KPICardComponent);
  registry.register(BarChartComponent);
  registry.register(LineChartComponent);

  // Navigation components
  registry.register(BreadcrumbComponent);
  registry.register(PaginationComponent);
  registry.register(FilterBarComponent);
  registry.register(SearchBarComponent);
  registry.register(LanguageSwitcherComponent);
  registry.register(AppBaseHeaderComponent);
  registry.register(AppBaseNavigationComponent);
  registry.register(AppBaseFooterComponent);
}
